import React from "react";
import {
  PoweredByCognixis as CognixisPoweredBy,
  VersionDisplay,
} from "@cognixis-technology/common-react-components";
import { getAppVersionLabel } from "../config/build-version-label";
import "./PoweredByCognixis.css";

// Version display component for login page

export const PoweredByCognixis: React.FC = () => {
  return (
    <div className="powered-by-cognixis-wrapper">
      <CognixisPoweredBy />
    </div>
  );
};

export const VersionDisplayComponent: React.FC = () => {
  return (
    <div className="version-display-wrapper">
      <VersionDisplay version={getAppVersionLabel()} />
    </div>
  );
};
